import React from 'react';
import { Users, FileKey } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './Tabs';
import { PermissionsParticipantsTab } from './PermissionsParticipantsTab';
import { PermissionsFilesTab } from './PermissionsFilesTab';
import { usePermissions } from '../helpers/usePermissionsApi';
import styles from './PermissionsPanel.module.css';

interface PermissionsPanelProps {
  sessionId: string;
}

export const PermissionsPanel = ({ sessionId }: PermissionsPanelProps) => {
  const { data, isLoading } = usePermissions(sessionId);

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <h3 className={styles.title}>Access Control</h3>
      </div>

      <Tabs defaultValue="participants" className={styles.tabs}>
        <TabsList className={styles.tabsList}>
          <TabsTrigger value="participants" className={styles.tabTrigger}>
            <Users size={14} className={styles.tabIcon} />
            Participants
          </TabsTrigger>
          <TabsTrigger value="files" className={styles.tabTrigger}>
            <FileKey size={14} className={styles.tabIcon} />
            File Permissions
          </TabsTrigger>
        </TabsList>

        <div className={styles.contentArea}>
          <TabsContent value="participants">
            <PermissionsParticipantsTab
              sessionId={sessionId}
              participants={data?.participants || []}
              isLoading={isLoading}
            />
          </TabsContent>

          <TabsContent value="files">
            <PermissionsFilesTab
              sessionId={sessionId}
              filePermissions={data?.filePermissions || []}
              isLoading={isLoading}
            />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
